import React from 'react';
import { filterListingUrl } from '../utils/orcanosLinks';
import '../styles/OpenFilterLink.css';

/**
 * "Open in Orcanos" — a small ↗ button next to a filter field that opens that filter's
 * item listing in a new tab, so the user can see what the filter actually returns before
 * committing to it.
 *
 * Renders NOTHING until every part of the URL is known (base URL, version, item-type code,
 * filter id). A half-built link would open the tenant root and read as a broken feature.
 *
 * `itemTypeCode` must be the ORIGINAL CODE, not the display label — see utils/orcanosLinks.
 */
function OpenFilterLink({ baseUrl, versionId, itemTypeCode, filterId, label = 'filter' }) {
  const url = filterListingUrl(baseUrl, versionId, itemTypeCode, filterId);
  if (!url) return null;

  const title = `Open this ${label} in Orcanos (new tab)`;
  return (
    <a
      className="ofl-link"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      aria-label={title}
    >
      <span className="ofl-icon" aria-hidden="true">↗</span>
      <span className="ofl-text">Open in Orcanos</span>
    </a>
  );
}

export default OpenFilterLink;
